import { Loader2 } from 'lucide-react'

import { BotMessage } from '@/components/admin/insights/chat/BotMessage'
import { CaseWorkerMessage } from '@/components/admin/insights/chat/CaseWorkerMessage'
import { MarkdownWrapper } from '@/components/MarkdownWrapper'
import { AnalyticsChatItem } from '@/store/chat'

import { ChartCard } from '../cards/ChartCard'
import { KPICard } from '../cards/KPICard'
import { BeneficiaryInsightsCta } from './Cta'

export function Chat({ items, isThinking }: { items: AnalyticsChatItem[]; isThinking: boolean }) {
  return (
    <>
      {items.map((item) => {
        if (item.type === 'insightDisplay' && item.data.type === 'kpi') {
          return (
            <KPICard
              key={item.id}
              title={item.data.title}
              value={item.data.value.toString()}
              description={item.data.description}
            />
          )
        } else if (item.type === 'insightDisplay' && item.data.type === 'chart') {
          return (
            <ChartCard
              key={item.id}
              title={item.data.title}
              description={item.data.description}
              chart={item.data.value}
            />
          )
        } else if (item.type === 'cta' && item.cta === 'beneficiaryInsights') {
          return <BeneficiaryInsightsCta key={item.id} item={item} />
        } else if (item.type === 'message' && 'content' in item) {
          if (item.isFromUser)
            return <CaseWorkerMessage key={item.id}>{item.content}</CaseWorkerMessage>
          return (
            <BotMessage key={item.id} traceUrl={item.traceUrl}>
              <MarkdownWrapper content={item.content} />
            </BotMessage>
          )
        }
      })}
      {isThinking && (
        <BotMessage key="thinking">
          <Loader2 className="min-h-5 min-w-5 animate-spin" />
        </BotMessage>
      )}
    </>
  )
}
